import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-mws-realtime-orders-identity',
  templateUrl: './help-mws-realtime-orders-identity.component.html'
})
export class HelpMwsRealtimeOrdersIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
